// import moment from 'moment';

export function getCurrentDate() {
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  const yyyy = today.getFullYear();

  return yyyy + '-' + mm + '-' + dd;
}

export function getFormattedJsonDateTime(dateTimeStr: string | undefined) {
  if (dateTimeStr === undefined || dateTimeStr === '') {
    return undefined;
  }

  const dt = new Date(dateTimeStr);

  const year = dt.getFullYear().toString();
  const month = (1 + dt.getMonth()).toString().padStart(2, '0');
  const day = dt.getDate().toString().padStart(2, '0');

  const hours = dt.getHours().toString().padStart(2, '0');
  const minutes = dt.getMinutes().toString().padStart(2, '0');
  const seconds = dt.getSeconds().toString().padStart(2, '0');

  return year + '-' + month + '-' + day + 'T' + hours + ':' + minutes + ':' + seconds;
}

export function getFormattedDateTime(dateTimeStr: string | undefined) {
  if (dateTimeStr === undefined || dateTimeStr === null || dateTimeStr === '') {
    return '';
  }

  const dt = new Date(dateTimeStr);

  const year = dt.getFullYear();
  const month = 1 + dt.getMonth();
  const day = dt.getDate().toString().padStart(2, '0');

  let hours = dt.getHours();
  let ampm = 'AM';
  if (hours > 11) ampm = 'PM';
  if (hours > 12) hours -= 12;

  const minutes = dt.getMinutes();
  const minutesStr = minutes < 10 ? '0' + minutes.toString() : minutes.toString();
  const seconds = dt.getSeconds();
  const secondsStr = seconds < 10 ? '0' + seconds.toString() : seconds.toString();

  return `${month}/${day}/${year} ${hours}:${minutesStr}:${secondsStr} ${ampm}`;
}

export function getFormattedCurrentTime() {
  const d = new Date();
  let mn = '';
  const m = d.getMinutes();
  if (m < 10) {
    mn = '0' + m.toString();
  } else {
    mn = m.toString();
  }
  let sc = '';
  const s = d.getSeconds();
  if (s < 10) {
    sc = '0' + s.toString();
  } else {
    sc = s.toString();
  }

  let h = d.getHours();
  let ampm = 'am';
  if (h >= 12) {
    h -= 12;
    ampm = 'pm';
  }
  const hr = h.toString();

  return hr + ':' + mn + ':' + sc + ' ' + ampm;
}

export function getFormattedCurrentDateTime() {
  const dt = new Date();
  return getFormattedJsonDateTime(dt.toString());
}

export function getFormattedDate(dateStr: string | undefined) {
  if (dateStr === undefined || dateStr === '') {
    return undefined;
  }

  const d = new Date(dateStr);

  if (d.valueOf() === 0) return '';

  const year = d.getFullYear().toString();
  const month = (1 + d.getMonth()).toString().padStart(2, '0');
  const day = d.getDate().toString().padStart(2, '0');

  return year + '-' + month + '-' + day;
}

export default function formatDate(dateString: string | undefined, prefix?: string) {
  if (dateString === undefined) return '';
  if (prefix === undefined) prefix = '';
  const d = new Date(dateString);
  if (d <= new Date('1-1-1980')) return '';
  return typeof d === 'object' ? prefix + d.toLocaleDateString() : '';
}

export function dateToString(d: Date | undefined) {
  if (d === undefined) return '';
  return new Date(d).toLocaleDateString();
}

export function dateStringToString(ds: string | undefined) {
  if (ds === undefined) return '';
  const dn = Date.parse(ds);

  return new Date(dn).toLocaleDateString();
}

// export function getConversationFormattedDate(latestDateTime: string): string {
//   if (latestDateTime === '') return '';
//   const currentDateTime = moment().local();
//   let timeStamp = '';
//   const diffHours = moment.duration(currentDateTime.diff(latestDateTime)).asHours();
//   if (diffHours <= 24) {
//     timeStamp = moment(latestDateTime).local().format('h:mm a');
//   } else {
//     timeStamp = moment(latestDateTime).local().format('M/D');
//   }
//   return timeStamp;
// }
